
import React, { useMemo } from 'react';
import DataTableGrid from '../../../../components/common/DataTableGrid';
import { Column } from 'react-table';
import { DailySummaryItem } from '../types';
import './DailySummaryTable.scss'; 

interface Props {
  data: DailySummaryItem[];
  columns: Column<DailySummaryItem>[];
  maxHeight?: string;
}

const DailySummaryTable: React.FC<Props> = ({ data = [], columns = [], maxHeight = '450px' }) => {
  const columnsForGrid = useMemo(() => columns || [], [columns]);

  return (
    <div className='daily-summary-table-container'>
      <DataTableGrid data={data} columns={columnsForGrid} maxHeight={maxHeight} />
    </div>
  );
};

export default DailySummaryTable;
